import { LOGO_URL, COMPANY } from "@/lib/api";
import { Phone, MapPin, Mail, Clock } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#1A2B1E] text-[#F9F8F6] mt-32" data-testid="site-footer">
      <div className="ff-container py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="bg-white inline-block p-3">
            <img src={LOGO_URL} alt="FineFood Primeur" className="h-16 w-auto" />
          </div>
          <p className="mt-6 text-[#C9D2CC] max-w-md leading-relaxed">
            Votre primeur professionnel à Genève. Fruits & légumes frais livrés rapidement
            aux restaurateurs et commerçants depuis Le Lignon.
          </p>
          <div className="mt-6 flex gap-6 text-sm text-[#C9D2CC]">
            <span>Prix compétitifs</span>
            <span>Fiabilité</span>
            <span>Rapidité</span>
          </div>
        </div>

        <div>
          <h4 className="ff-overline mb-5 text-[#F4A261]">Contact</h4>
          <ul className="space-y-3 text-sm text-[#C9D2CC]">
            <li className="flex items-start gap-2">
              <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
              <span>
                {COMPANY.address}<br />
                {COMPANY.postal} {COMPANY.city}
              </span>
            </li>
            <li className="flex items-center gap-2">
              <Phone className="w-4 h-4 shrink-0" />
              <a href={`tel:${COMPANY.phone}`} data-testid="footer-phone-link" className="hover:text-white">{COMPANY.phone}</a>
            </li>
            <li className="flex items-center gap-2">
              <Mail className="w-4 h-4 shrink-0" />
              <a href={`mailto:${COMPANY.email}`} className="hover:text-white">{COMPANY.email}</a>
            </li>
            <li className="flex items-center gap-2">
              <Clock className="w-4 h-4 shrink-0" />
              Lun – Sam · 04h – 12h
            </li>
          </ul>
        </div>

        <div>
          <h4 className="ff-overline mb-5 text-[#F4A261]">Espace pro</h4>
          <ul className="space-y-3 text-sm text-[#C9D2CC]">
            <li><Link to="/login" className="hover:text-white">Connexion client</Link></li>
            <li><Link to="/register" className="hover:text-white">Demander un compte</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#2A3D2E]">
        <div className="ff-container py-6 flex flex-col md:flex-row justify-between text-xs text-[#8A9A8E]">
          <span>© {new Date().getFullYear()} FineFood Primeur · Tous droits réservés</span>
          <span>Genève, Suisse</span>
        </div>
      </div>
    </footer>
  );
}
